import { Home, Target, Flame, User, Users } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function BottomNav() {
  const location = useLocation();
  const { t } = useTranslation('common');

  const navItems = [
    { label: t('nav.home'), icon: Home, href: '/home' },
    { label: t('nav.pillars'), icon: Target, href: '/pilares' },
    { label: t('nav.groups'), icon: Users, href: '/grupos' },
    { label: 'Desafios', icon: Flame, href: '/meus-desafios' },
    { label: t('nav.profile'), icon: User, href: '/perfil' },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background md:hidden" 
      data-tour="bottom-nav"
      role="navigation" 
      aria-label="Main navigation"
    >
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'flex flex-col items-center justify-center py-3 px-4 text-xs transition-colors flex-1 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-lg',
                isActive
                  ? 'text-primary font-medium'
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <Icon className={cn('h-5 w-5 mb-1', isActive && 'stroke-2')} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}